import Service from './service'
export var ApiEnvironmentMessageType;
(function (ApiEnvironmentMessageType) {
  ApiEnvironmentMessageType["ENVIRONMENT_GET"] = "system.environment.get"
  ApiEnvironmentMessageType["ENVIRONMENT_LOAD"] = "system.environment.load"
})(ApiEnvironmentMessageType || (ApiEnvironmentMessageType = {}))
/**
 * Сервис для работы с данными о среде запуска
 * @version 0.0.1
 * @since 1.9.0
 */
export default class EnvironmentService extends Service {
  /**
     * @ignore
     */
  constructor(messageChannel) {
    super(messageChannel)
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiEnvironmentMessageType.ENVIRONMENT_LOAD:
          this.resolve(this.waiters.environment, message.environment)
          break
      }
    }
    this.waiters = {
      environment: [],
    }
    this.messageChannel.subscribe(ApiEnvironmentMessageType.ENVIRONMENT_LOAD, messageHandler)
  }
  /**
     * Получить данные о среде
     * @since 1.9.0
     *
     * @return {*}  {Promise<Environment>}
     * @memberof EnvironmentService
     *
     * @example <caption>Получить данные о среде</caption>
     * robot.environmentService.get().then((env) => {
     *   console.log(env)
     * })
     */
  get() {
    return this.execute({
      type: ApiEnvironmentMessageType.ENVIRONMENT_GET,
      data: null,
    }, this.waiters.environment)
  }
}
